module.exports = __webpack_public_path__ + "static/media/Custard tart.0cfa0210.jpg";